<template>
  <div class="relative group">
    <slot></slot>
    <div
      v-if="show"
      class="absolute z-10 px-2 py-1.5 text-sm font-medium text-white bg-neutral-800/90 rounded-lg shadow-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 tooltip whitespace-nowrap pointer-events-none"
      :class="[positionClass]"
    >
      {{ text }}
      <div class="tooltip-arrow" :class="arrowClass" data-popper-arrow></div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Tooltip",
  props: {
    text: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      default: "bottom",
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    positionClass() {
      switch (this.position) {
        case "bottom":
          return "top-full left-1/2 transform -translate-x-1/2 mt-2";
        case "left":
          return "right-full top-1/2 transform -translate-y-1/2 mr-2";
        case "right":
          return "left-full top-1/2 transform -translate-y-1/2 ml-2";
        case "top":
        default:
          return "bottom-full left-1/2 transform -translate-x-1/2 mb-2";
      }
    },
    arrowClass() {
      switch (this.position) {
        case "bottom":
          return "bottom-full left-1/2 transform -translate-x-1/2 -mb-1";
        case "left":
          return "left-full top-1/2 transform -translate-y-1/2 -ml-1";
        case "right":
          return "right-full top-1/2 transform -translate-y-1/2 -mr-1";
        case "top":
        default:
          return "top-full left-1/2 transform -translate-x-1/2 -mt-1";
      }
    },
  },
};
</script>
